import { ReportCard } from "./components/ReportCard";
import { ReportCardSkeleton } from "./components/ReportCardSkeleton/ReportCardSkeleton";
import { useGetReportsQuery } from "./api/reports.api";

export function ReportsPage() {
  const { data } = useGetReportsQuery();
  const reports = data?.items;

  return (
    <div className="flex flex-col gap-4 p-4 sm:p-6">
      {reports ? reports.map((report) => <ReportCard key={report.id} report={report} />) : <ReportCardSkeleton />}
    </div>
  );
}
